<template>
  <div class="RealTimeQuality">

    <div class="Escalation"><span class="time">上次成功上报：{{ logCreateTime }}</span>
      <el-button type="primary" size="small" @click="sendLog()">日志上报
      </el-button>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="帧率" name="Frame"></el-tab-pane>
      <el-tab-pane label="码率" name="Code"></el-tab-pane>
      <el-tab-pane label="丢包率" name="Packet"></el-tab-pane>
      <el-tab-pane label="时延" name="delay"></el-tab-pane>
      <el-tab-pane label="CPU 使用率" name="CPU" v-if="$route.query.dType != 5 && $route.query.dType != 6" ></el-tab-pane>
      <el-tab-pane label="内存占用" name="Memory"  v-if="$route.query.dType != 5 && $route.query.dType != 6 " ></el-tab-pane>
    </el-tabs>
    <div id="cechart"></div>

    <!-- 日志上报弹框 -->
    <el-dialog
      title="日志上报"
      :visible.sync="logDialogVisible"
      width="500px"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :append-to-body="true"
      :modal-append-to-body="true"
      :lock-scroll="true">
      <div>
        <el-form label-width="100px">
          <el-form-item label="问题描述：">
            <el-input
              v-model="faultDescription"
              type="textarea"
              :rows="4"
              placeholder="请输入问题描述"
              maxlength="500"
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="logLoading" @click="confirmSendLog">上报</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {
  getUserQualityFactList, reportLogToLeboCloud, getReprotStatus
} from "@/api/rabbit/detail";
import * as echarts from 'echarts';
export default {
  data() {
    return {
      logCreateTime: '暂无',
      loading: false,
      myChart: '',
      activeName: 'Frame',
      Frame: {}, //帧率
      Code: {}, //码率
      Packet: {},//丢包率
      delay: {},//时延
      CPU: {},//CPU 使用率
      Memory: {}, //内存占用
      timeLine: {},//时间戳
      // 日志上报弹框
      logDialogVisible: false,
      faultDescription: '',
      logLoading: false
    }
  },
  props: {
    uid: {
      type: String,
      default: ''
    },
    appid: {
      type: String,
      required: true
    },
  },
  mounted() {
    this.loading = false
    this.init()
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById('cechart'));
  },
  watch: {
    '$route.path': {
      handler(val) {
        if (val === '/rabbit/user-detail') {
          if(!this.$route.query.code) return
          this.init()
          // 基于准备好的dom，初始化echarts实例
          this.myChart = echarts.init(document.getElementById('cechart'));
        }
      },
      deep: true
    },
  },
  beforeDestroy() {
    // 离开页面停止轮询
    this.loading = false
  },
  methods: {
    // 日志上报
    sendLog: function() {
      this.logDialogVisible = true
      this.faultDescription = ''
    },

    // 确认上报日志
    async confirmSendLog() {
      if (!this.faultDescription.trim()) {
        this.$message.warning('请输入问题描述')
        return
      }

      this.logLoading = true
      try {
        const params = {
          uid: this.uid,
          description: this.faultDescription.trim(),
          appId: this.appid
        }

        let res = await reportLogToLeboCloud(params)
        console.log('日志上报响应:', res)

        if (res.data && res.data.code === 200) {
          this.$message.success('已通知客户端上报日志')
          this.logDialogVisible = false
          this.getLog()
        } else {
          this.$message.error((res.data && res.data.message) || '通知客户端上报日志失败')
        }
      } catch (error) {
        console.error('日志上报失败:', error)
        this.$message.error('日志上报失败，请稍后重试')
      } finally {
        this.logLoading = false
      }
    },
    // 轮询获取日志时间
    async getLog() {
      let res = await getReprotStatus({ uid: this.uid })
      if (res.data.data.createTime) {
        this.loading = false
        this.logCreateTime = res.data.data.createTime
      }
      setTimeout(() => {
        if (res.data.data.createTime == "" && this.loading) {
          this.getLog()
        }
      }, 5000)

    },
    //时间戳转换
    formatDate(date, fmt) {
      let o = {
        'M+': date.getMonth() + 1,                    //月份
        'd+': date.getDate(),                        //日
        'h+': date.getHours(),                       //小时
        'm+': date.getMinutes(),                     //分
        's+': date.getSeconds(),                     //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds()                 //毫秒
      };
      if (/(y+)/.test(fmt)) {   //年份
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          let str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
        }
      }
      return fmt;
    },
    padLeftZero(str) {
      return ('00' + str).substr(str.length);
    },
    // 设置图表
    echartsSet(legendList, xAxisList, seriesData) {
      let eriesList = legendList.map((item) => {
        return {
          data: seriesData[item.data],
          type: 'line',
          name: item.name
        }
      })
      let legendData = legendList.map((item) => { return item.name })
      let xAxisData = xAxisList.map(item => { return this.formatDate(new Date(+item), 'hh:mm') })//时间线  'yyyy-MM-dd hh:mm'
      // 绘制图表
      this.myChart.setOption(
        {
          dataZoom: [{
            type: 'inside', //1平移 缩放
            throttle: '50', //设置触发视图刷新的频率。单位为毫秒（ms）。
            minValueSpan: 6, //用于限制窗口大小的最小值,在类目轴上可以设置为 5 表示 5 个类目
            start: 1, //数据窗口范围的起始百分比 范围是：0 ~ 100。表示 0% ~ 100%。
            end: 50, //数据窗口范围的结束百分比。范围是：0 ~ 100。
            zoomLock: true, //如果设置为 true 则锁定选择区域的大小，也就是说，只能平移，不能缩放。
          }],
          // 主要用来控制图表四周留白
          grid: {
            left: '130px',
            top: '15%',
            right: '5%',
            bottom: '15%',
          },

          legend: {
            data: legendData //表头
          },
          xAxis: {
            data: xAxisData
          },
          tooltip: {},
          yAxis: {},
          series: eriesList
        }, true
      );
    },
    //点击切换图表数据
    handleClick() {
      this.echartsSet(this[this.activeName].legendList, this.timeLine.localTimestamp, this[this.activeName])
    },
    // 获得全部图表数据
    async init() {
      this.activeName = 'Frame'
      let params = {
        roomId:this.$route.query.roomid,
        code: this.$route.query.code,
        sdkUserId: this.$route.query.uid,
        current: 1,
        size: -1,
      }
      if(!params.code) return
      try {
        let data = await getUserQualityFactList(params)

        let list = data.data.data.records
        // 分成7份数据，对应6个table和一个时间线
        this.Frame = {
          legendList: [{ name: '回调帧率', data: 'receiveFps' }, { name: '输入帧率', data: 'feedFps' }, { name: '输出帧率', data: 'outFps' }],
          feedFps: [],//输入帧率
          outFps: [], //输出帧率
          receiveFps: []//回调帧率
        }, //帧率
          this.Code = {
            legendList: [{ name: '第三方回调码率', data: 'receiveRate' }, { name: '输入码率', data: 'feedRate' }, { name: '设备下行码率', data: 'deviceDownRate' }],
            receiveRate: [], //第三方回调码率
            deviceDownRate: [],//设备下行码率
            feedRate: [], //输入码率

          }, //码率
          this.Packet = {
            legendList: [{ name: '丢包率', data: 'loss' }],
            loss: [], //丢包率
          },//丢包率
          this.delay = {
            legendList: [{ name: '网关RTT延时', data: 'gatewayRtt' }, { name: '云桌面RTT延时', data: 'cloudRtt' }],
            gatewayRtt: [], //网关rtt延时
            cloudRtt: [], //云桌面rtt延时
          },//时延
          this.CPU = {
            legendList: [{ name: '应用CPU', data: 'leboappUseCpuRate' },{ name: '系统CPU', data: 'cpuRate' }],
            leboappUseCpuRate:[], //乐播app的CPU占用率
            cpuRate: [], //CPU占用率
          },//CPU 使用率
          this.Memory = {
            legendList: [{ name: 'APP内存', data: 'memoryBytes' },{ name: '内存百分比', data: 'memoryRate' },{ name: '系统总内存', data: 'totalMemoryBytes' },{ name: '可用内存数', data: 'freeMemoryBytes' }],
            freeMemoryBytes: [], //可用内存数
            memoryBytes: [], //内存占用字节数
            memoryRate: [], //内存占用百分比
            totalMemoryBytes: [], //总内存
          }, //内存占用
          this.timeLine = { localTimestamp: [] }//时间戳
        // 排序
        list = list.sort((a, b) => {
          return a.localTimestamp - b.localTimestamp
        })
        list.forEach((item) => {
          this.Frame.feedFps.push(item.feedFps)
          this.Frame.outFps.push(item.outFps)
          this.Frame.receiveFps.push(item.receiveFps)
          this.Code.deviceDownRate.push(item.deviceDownRate)
          this.Code.feedRate.push(item.feedRate)
          this.Code.receiveRate.push(item.receiveRate)
          this.Packet.loss.push(item.loss)
          this.delay.gatewayRtt.push(item.gatewayRtt)
          this.delay.cloudRtt.push(item.cloudRtt)
          this.CPU.cpuRate.push(item.cpuRate)
          this.CPU.leboappUseCpuRate.push(item.leboappUseCpuRate)
          this.Memory.freeMemoryBytes.push(item.freeMemoryBytes)
          this.Memory.memoryBytes.push(item.memoryBytes)
          this.Memory.memoryRate.push(item.memoryRate)
          this.Memory.totalMemoryBytes.push(item.totalMemoryBytes)
          this.timeLine.localTimestamp.push(item.localTimestamp)
        })
        console.log(' this.delay.gatewayRtt', this.delay.gatewayRtt)
        console.log(' this.delay.cloudRtt', this.delay.cloudRtt)
        //默认
        this.echartsSet(this.Frame.legendList, this.timeLine.localTimestamp, this.Frame)

      } catch (err) {
        console.log(err)
      }
    }

  }
}
</script>
<style  lang="scss" scoped>
.RealTimeQuality {
  .Escalation {
    text-align: right;
    height: auto;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .time {
      margin-right: 15px;
      color: #6A6565 100%;
      font-size: 14px;
      font-family: SourceHanSansSC-regular;
    }
  }

  #cechart {
    width: 100%;
    height: 306px;
    background-color: #f8f6f6;
    padding-top: 34px;
  }
}

/deep/.el-tabs__nav-wrap::after {
  background-color: #fff !important;
}
</style>